import { api } from '../../../services/api';

export const applicationsApi = {
  /**
   * Récupérer les détails d'une candidature
   */
  getById: async (id: string) => {
    const response = await api.get(`/applications/admin/${id}`);
    // Le backend retourne { success: true, data: booking }
    return response.data.data;
  },

  /**
   * Approuver une candidature
   */
  approve: async (id: string, adminNotes?: string) => {
    const response = await api.post(`/applications/admin/${id}/approve`, { adminNotes });
    return response.data;
  },

  /**
   * Rejeter une candidature
   */
  reject: async (id: string, reason: string) => {
    const response = await api.post(`/applications/admin/${id}/reject`, { reason });
    return response.data;
  },

  /**
   * Confirmer la réception d'un paiement
   */
  confirmPayment: async (id: string, data: { paymentMode: string; monthNumber: number; periodMonths?: number }) => {
    const response = await api.post(`/applications/admin/${id}/confirm-payment`, data);
    return response.data;
  },

  /**
   * Clôturer un dossier de candidature
   */
  closeApplication: async (id: string, reason: string) => {
    const response = await api.post(`/applications/admin/${id}/close`, { reason });
    return response.data;
  },
};
